/** Public URL path for the bundled default editor-scripts package (web + Tauri frontend). */
export const DEFAULT_EDITOR_SCRIPTS_ASSET_PATH = "/default-editor-scripts.curva";

/** Filename inside AppConfig / Tauri resources. */
export const DEFAULT_EDITOR_SCRIPTS_FILENAME = "default-editor-scripts.curva";

/**
 * Fetch the build-generated default editor-scripts package from the frontend asset.
 * Works in browser and Tauri webview when the file is copied into `dist/`.
 */
export async function fetchBundledDefaultEditorScriptsBytes(): Promise<Uint8Array | undefined> {
  try {
    const response = await fetch(DEFAULT_EDITOR_SCRIPTS_ASSET_PATH);
    if (!response.ok) {
      return undefined;
    }
    const buffer = await response.arrayBuffer();
    if (buffer.byteLength === 0) {
      return undefined;
    }
    return new Uint8Array(buffer);
  } catch (error) {
    console.warn("[curva] failed to fetch bundled default editor scripts", error);
    return undefined;
  }
}
